import { Component, Input, Output, EventEmitter, TemplateRef, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';

export interface TableColumn<T = any> {
  key: string;
  header: string;
  template?: TemplateRef<any>;
  sortable?: boolean;
  width?: string;
}

@Component({
  selector: 'app-generic-table',
  standalone: false,
  templateUrl: './generic-table.html',
  styleUrl: './generic-table.css'
})
export class GenericTable<T = any> implements AfterViewInit {
  @Input() set data(value: T[] | MatTableDataSource<T>) {
    if (value instanceof MatTableDataSource) {
      this.dataSource = value;
    } else {
      this.dataSource.data = value || [];
    }
  }
  
  dataSource = new MatTableDataSource<T>([]);
  
  @Input() columns: TableColumn<T>[] = [];
  @Input() displayedColumns: string[] = [];
  @Input() loading = false;
  @Input() emptyStateIcon = 'inbox';
  @Input() emptyStateTitle = 'No Data Found';
  @Input() emptyStateMessage = 'There are no items to display';
  @Input() showActions = false;
  @Input() showViewAction = true;
  @Input() showPaginator = true;
  @Input() showSort = true;
  @Input() actionColumnWidth = '100px';

  @Output() rowClick = new EventEmitter<T>();
  @Output() view = new EventEmitter<T>();
  @Output() edit = new EventEmitter<T>();
  @Output() delete = new EventEmitter<T>();

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) internalPaginator!: MatPaginator;
  
  @Input() externalPaginator?: MatPaginator;

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit() {
    setTimeout(() => {
        this.dataSource.sort = this.showSort ? this.sort : null;
        if (this.externalPaginator) {
            this.dataSource.paginator = this.externalPaginator;
        } else if (this.internalPaginator && this.showPaginator) {
            this.dataSource.paginator = this.internalPaginator;
        }
        this.cdr.detectChanges();
    });
  }

  onRowClick(item: T): void {
    this.rowClick.emit(item);
  }
  onView(item: T, event: Event): void {
    event.stopPropagation();
    this.view.emit(item);
  }

  onEdit(item: T, event: Event): void {
    event.stopPropagation();
    this.edit.emit(item);
  }

  onDelete(item: T, event: Event): void {
    event.stopPropagation();
    this.delete.emit(item);
  }

  trackByFn(index: number, item: T): any {
    return (item as any)?.id ?? index;
  }

  getGlobalIndex(localIndex: number): number {
    const paginator = this.externalPaginator ?? this.internalPaginator;
    if (!paginator) return localIndex;
    return paginator.pageIndex * paginator.pageSize + localIndex;
  }
}
